/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFriendliWhiteLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 6v28c0 3.32 2.68 6 6 6h28c3.32 0 6-2.68 6-6V6c0-3.32-2.68-6-6-6H6C2.68 0 0 2.68 0 6Zm11.12 1.2c2.16 0 3.92 1.76 3.92 3.92s-1.76 3.92-3.92 3.92-3.92-1.76-3.92-3.92S8.96 7.2 11.12 7.2Zm0 25.6c-2.16 0-3.92-1.76-3.92-3.92s1.76-3.92 3.92-3.92 3.92 1.76 3.92 3.92-1.76 3.92-3.92 3.92Zm4.28-16.08c-.6.84-.64 2.04-.6 2.72v1.88c0 1.24-1.04 2.28-2.28 2.28H9.8c-1.24 0-2.28-1.04-2.28-2.28v-2.68c0-1.28 1.04-2.28 2.28-2.28h1.6c.28 0 1 0 1.28-.08.28-.04 1.12-.24 1.88-.84.08-.08.16-.12.24-.2 0 0 .2-.16.36-.32.44-.48.8-1.12.8-1.12.12-.2.36-.72.52-1.48.08-.36.12-.68.12-.96l.08-1.6c0-1.28 1.04-2.28 2.28-2.28h2.64c1.28 0 2.28 1.04 2.28 2.28v2.68c0 1.28-1.04 2.28-2.28 2.28h-2.16c-.52 0-.92.08-1.24.12-.56.12-.84.24-.96.28-.4.16-.72.4-.84.52-.04.08-.64.56-1 1.08Zm17.4-4.16c0 1.24-1 2.2-2.2 2.2-.64-.04-1.16 0-1.56 0-.64.04-1.04.08-1.56.24-.56.16-1 .4-1.2.56-.12.08-.48.32-.96.72-.28.24-.52.44-.76.8-.36.48-.52.96-.6 1.2-.2.64-.24 1.56-.24 2l-.04 1.16c0 1.24-1 2.2-2.2 2.2h-2.8c-1.2 0-2.2-1-2.2-2.2v-2.8c0-1.24 1-2.2 2.2-2.2h1.68c.6 0 1.8.04 2.8-.32.88-.32 1.72-1.2 2.08-2.16.32-.96.32-2.28.32-2.28V9.8c0-1.24 1-2.2 2.2-2.2h2.8c1.24 0 2.2 1 2.2 2.2v2.76h.04Z"
    />
  </svg>
);

export default SvgFriendliWhiteLogo;
